var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-fields-group clearfix"},[_vm._l((_vm.activeFields),function(field){return [_c('field-layout-pre',{key:'pre-' + field.id,attrs:{"field":field}}),_c('field-layout',{key:field.id,attrs:{"field":field}}),_c('field-layout-pos',{key:'pos-' + field.id,attrs:{"field":field}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }